module.exports = __webpack_public_path__ + "media/images/covid/icons/sanitizer-1444e0a7a231768263f0072a1d1a016d.png";